const setSideBarStatus = (state, action) => {
  state.displaySideBar = action.payload;
};

export default {
  setSideBarStatus,
};
